var is_mobile = false;

$.fn.exists = function () {
    return this.length !== 0;
};

jQuery(document).ready(function () {
    function isMobile() {
        var check = false;
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
            check = true;
        }
        return check;
    }

    $('.header__btn-sign, .sign-up-js, .page-loglink, .get-inside_click, .btn--popup').on('click', function () {
        var position = $(this).data('position');
        if (position) {
            $('#sign-up input[name="form_position"]').val($(this).data('position'));
        }

        $('#sign-up input[name="SignUp[form_id]"]').val($(this).data('form'));
        $('#sign-up, #overlay').fadeIn(1);
    });

    var popupModal = $('.modal__wrapper');
    $(document).on('click', '.modal', function (e) {
        popupModal.closest('.modal').not('#blog-success-modal').each(function () {
            if (!popupModal.is(e.target) && popupModal.has(e.target).length === 0) {
                $(this).find('.modal__close').trigger('click');
            }
        });
    });



    if ($('.button--sign-up').length > 0) {

        let signUpPopup = $('#sign-up');
        let signUpBtn = $('.button--sign-up');

        $('body').on('click', '.button--sign-up', function () {
            var position = $(this).data('position');
            if (position) {
                $('#sign-up input[name="form_position"]').val($(this).data('position'));
            }

            $('#sign-up input[name="SignUp[form_id]"]').val($(this).data('form'));

            dataLayer.push({ 'event': 'View Register Form Popup' });
            signUpPopup.css('display', 'flex');

        });

        $('.modal__close').click(function () {
            signUpPopup.hide();
            $('#sign-up .has-error').removeClass('has-error');
            $('#sign-up .modal__error').text('');
            $('#sign-up [id^="signup-email"]').val('');
        });
    }


    $('.btn-ref').on('click', function () {
        $('#sign-up-earn input[name="SignUp[form_id]"]').val($(this).data('form'));
        $('#sign-up-earn, #overlay').fadeIn(1);
    });

    $('.button--earn').on('click', function () {
        $('#sign-up-earn input[name="SignUp[form_id]"]').val($(this).data('form'));
        $('#sign-up-earn').css('display', 'flex');

        $('.modal__close').click(function () {
            $('#sign-up-earn').hide();
            $('#sign-up-earn .has-error').removeClass('has-error');
            $('#sign-up-earn .modal__error').text('');
            $('#sign-up-earn [id^="signup-email"]').val('');
        });
    });


    $('#user-register-marketer-form,#user-register-marketer-form-ctr, #user-register-marketer-form-2, #user-register-lm-form, #user-register-promo-form, ' +
        '#user-register-publishers-form, #user-register-publishers-form-2, #user-register-form, #user-register-form-popup, ' +
        '#user-register-form-bounce, #user-register-form-for, #user-register-form-earn, #user-register-form-media,' +
        ' #user-register-form-outreach, #user-register-form-outreach-2, #user-register-form-outreach-3, #registerFormEarn').on('beforeSubmit', function (e) {
            // e.preventDefault();
            // e.stopImmediatePropagation();
            var register_form = $(this);
            if (register_form.find('.has-error').length) {
                return false;
            }
            $.ajax({
                data: register_form.serialize(),
                dataType: 'json',
                method: 'POST',
                url: register_form.attr('action'),
                success: function (data) {
                    if (true === data.success) {
                        register_form.find('[id^="signup-email"]').val('');
                        $('.help-block-error').remove();
                        window.location = data.url;
                    }
                }
            });
            return false;
        });


    $('.close-btn, .icon--close').click(function () {
        $('#sign-up, #bounce-popup, #sign-up-earn, #overlay').fadeOut(10);
        return false;
    });
    $('#overlay').click(function () {
        if (!$('.bounce-register').is(':visible')) {
            $('#sign-up, #bounce-popup, #sign-up-earn, #overlay').fadeOut(10);
        }
        return false;
    });

    $('#blog-success-modal .modal__close').click(function () {
        $('#overlay').fadeOut(10);
        $('#blog-success-modal').fadeOut(1);
        $('#blog-register-form [id^="signup-email"]').val('');
        $('#blog-register-form [id^="signup-email"]').after('<p class="help-block help-block-error"></p>');
        $('#blog-register-form .field-signup-email').removeClass('has-error');
        $('#blog-register-form .help-block-error').text('');
        return false;
    });

    $('#contact-new-success-modal .modal__close').click(function () {
        $('#contact-new-success-modal').fadeOut();
        return false;
    });

    $('#contact-registered-success-modal .modal__close').click(function () {
        $('#contact-registered-success-modal').fadeOut();
        return false;
    });

    $('.form-loading').on('submit', function () {
        var button_text = $(this).find('.btn-loading').html();
        $(this).find('.btn-loading').html('Loading...');
        $(this).find('.btn-loading').attr('disabled', true);
        loading_form_check_error($(this), button_text, 0);
    });

    var blog_success_modal = $('#blog-success-modal');
    var popup_log_in_link = $('.popup-log-in-link');

    $('#blog-register-form').on('submit', function (e) {
        // e.preventDefault();
        // e.stopImmediatePropagation();
        var register_form = $(this);
        $.ajax({
            data: register_form.serialize(),
            dataType: 'json',
            method: 'POST',
            url: register_form.attr('action'),
            success: function (data) {
                if (true === data.success) {
                    popup_log_in_link.data('url', data.url);
                    $('#blog-register-form [id^="signup-email"]').val('');
                    $('#blog-register-form .field-signup-email .help-block-error').remove();
                    $('#overlay').fadeIn(1);
                    blog_success_modal.show();
                    blog_success_modal.css('display', 'flex');
                    register_form.find('.btn-loading').html('Sign up');
                    register_form.find('.btn-loading').removeAttr('disabled');
                }
            }
        });
        return false;
    });

    if (popup_log_in_link.data('url')) {
        blog_success_modal.show();
        blog_success_modal.css('display', 'flex');
    }

    popup_log_in_link.on('click', function () {
        window.location = $(this).data('url');
    });

    var contact_registered_success_modal = $('#contact-registered-success-modal');
    if (contact_registered_success_modal.length) {
        contact_registered_success_modal.css('display', 'flex');
    }

    var contact_new_success_modal = $('#contact-new-success-modal');
    if (contact_new_success_modal.length) {
        contact_new_success_modal.css('display', 'flex');
    }

    var user_register_form = $('#user-register-form');
    if (user_register_form.find('.help-block-error').html()) {
        $('html, body').animate({ scrollTop: user_register_form.offset().top }, 1000);
    }

    var sign_up = $('#sign-up');
    if (sign_up.find('.help-block-error').html()) {
        $('#sign-up .header__btn-sign').trigger('click');
    }

    var sign_up_earn = $('#sign-up-earn');
    if (sign_up_earn.find('.help-block-error').html()) {
        $('#sign-up-earn .header__btn-sign').trigger('click');
    }

    $('.faq__item').click(function (e) {
        if (e.target.tagName !== 'A') {
            let _this = $(this);
            let _id = _this.attr('id');

            _this.toggleClass('selected');
            _this.find('.faq__text').slideToggle();
            if (window.location.hash !== _id) {
                history.pushState({}, '', '#' + _id);
            }
        }
    });

    var callbackForm = $('.callback__form');
    var callbackPhone = $('.callback__phone');

    callbackPhone.click(function () {
        $(this).css('display', 'none');
        callbackForm.css('display', 'flex');
        $('.close-icon').css('display', 'block');
        $('.callback__answer').hide();
    });

    $('.close-icon').click(function () {
        $(this).css('display', 'none');
        callbackForm.css('display', 'none');
        callbackPhone.css('display', 'block');
        callbackPhone.css('opacity', '1');
    });

    var callback_process = 0;
    $('#callbackBottom').on('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (0 === callback_process) {
            callback_process = 1;
            var callback_form = $(this);
            $.ajax({
                data: callback_form.serialize(),
                dataType: 'json',
                method: 'POST',
                url: callback_form.attr('action'),
                success: function (data) {
                    if (true === data) {
                        $('#callbackform-phone').val('');
                        $('.callback .close-icon').trigger('click');
                        $('.callback__answer').show();
                        setTimeout(function () {
                            $('.callback__answer').hide();
                        }, 2000);
                    }
                    callback_process = 0;
                }
            });
        }
        return false;
    });


    $('.form__fieldset .form__wrap .help-block-error').bind('DOMSubtreeModified', function () {
        $(this).hide();
        $(this).parents('.form__fieldset').find('.error-js-added').remove();
        if ('' !== $(this).html()) {
            $(this).parents('.form__fieldset').append('<p class="help-block-error error-js-added">' + $(this).html() + '</p>');
        }
    });

    $('.dropdown .dropdown__list .help-block-error').bind('DOMSubtreeModified', function () {
        $(this).hide();
        $(this).parents('.dropdown').find('.error-js-added').remove();
        if ('' !== $(this).html()) {
            $(this).parents('.dropdown').append('<p class="help-block-error error-js-added">' + $(this).html() + '</p>');
        }
    });

    $('.btn:not(.btn--transparent):not(.btn--facebook):not(.btn--google):not(.btn--traffic):not(.btn--title):not(.btn-login):not(.btn--orange):not(.btn--demo)').click(function (e) {
        e.preventDefault();
        $('input[name="ContentCreationForm[form_id]"]').val($(this).data('form'));
        $('.wrapper--overlay').show();
        $('#makeRequest').show();
    });

    $('.button--services').on('click', function () {
        $('#servicesPopup').css('display', 'flex');
        $('#servicesPopup .modal__close').on('click', function () {
            $('#servicesPopup').fadeOut(10);
        });
    });

    $('.icon--close').on('click', function () {
        $(this).parents('.popup').hide();
        $('.wrapper--overlay').hide();
    });

    $('#approvedText').click(function (e) {
        e.preventDefault();
        var text = $(this).text();
        var startText = $(this).data('close');
        var hideText = $(this).data('open');
        $(this).next().toggle();
        text = text === startText ? hideText : startText;
        $(this).text(text);
    });

    $('#dropdownSelectForm').on('click', function (e) {
        $(this).next('.dropdown__list').slideToggle();
        e.preventDefault();
    });

    $('#dropdownSelectModalForm').on('click', function (e) {
        $(this).next('.dropdown__list').slideToggle('fast');
        e.preventDefault();
    });

    $('.blog__img-responsive:not([data-link])').each(function () {
        $(this).wrap('<a href="' + $(this).attr('src') + '" data-fancybox></a>');
    });
    $('.blog__img--post').each(function () {
        if (!$(this).parent('a').length) {
            $(this).wrap('<a href="' + $(this).attr('src') + '" data-fancybox></a>');
        }
    });
    if ($('[data-fancybox]') > 0) {
        $('[data-fancybox]').fancybox({
            buttons: [
                'zoom',
                'fullScreen',
                'download',
                'thumbs',
                'close',
            ],
        });
    }

    // if ($('.post__share').length > 0) {
    //     $(document).on('scroll', function() {
    //         if ($(document).scrollTop() > 165) {
    //             $('.post__share').addClass('fixed');
    //         } else {
    //             $('.post__share').removeClass('fixed');
    //         }
    //     });
    // }

    $('.btn__scroll--url').on('click', function () {
        $('html, body').animate({ scrollTop: $('#wrapper').offset().top }, 1000);
    });

    $('.button--scroll-next').on('click', function () {
        let next = $(this).closest('section').next('section');
        $('html, body').animate({ scrollTop: next.offset().top - 116 }, 1000);
    });

    //footer showmore
    $('.showmore__title').on('click', function () {
        $('.showmore__arrow').toggleClass('down');
        $('.showmore__wrapper').slideToggle();
    });


    // HEADER
    $('.header__burger').on('click', function () {
        $(this).toggleClass('open');
        $('body, .header, .header__nav.nav-new').toggleClass('open');
    });

    $(document).on({
        mouseenter: function () {
            if (!isMobile()) {
                $('.header__submenu').css('display', 'grid');
                $(this).find('.header__arrow').addClass('up');
            }
        }, mouseleave: function () {
            if (!isMobile()) {
                $('.header__submenu').css('display', 'none');
                $(this).find('.header__arrow').removeClass('up');
            }
        }, click: function () {
            // if (isMobile()) {
            if ($('.header__submenu').hasClass('collapsed')) {
                $('.header__submenu').removeClass('collapsed')
                $('.header__submenu').css('display', 'none');
                $(this).find('.header__arrow').removeClass('up');
            } else {
                $('.header__submenu').addClass('collapsed');
                $('.header__submenu').css('display', 'grid');
                $(this).find('.header__arrow').addClass('up');
            }
            // }

            // $(this).find('.header__arrow').addClass('up');
            // if ($(this).children('ul').exists()) {
            //     if ($(this).children('ul').css('display') === 'none') {
            //         $(this).addClass('hover');
            //         $(this).find('.header__arrow').addClass('up');
            //     } else {
            //         $('.header__submenu').css('display', 'none');
            //         $(this).find('.header__arrow').removeClass('up');
            //     }
            //     return false;
            // }
        }
    }, '.header__item.header__item--expand');

    $('.header__subitem')
        .hover(function () {
            if (!isMobile()) {
                if ($(this).children('.header__sublist').exists()) {
                    $(this).children('.header__sublink').addClass('disabled');
                    $(this).children('.header__sublist').show();
                }
            }
        }, function () {
            if (!isMobile()) {
                if ($(this).children('.header__sublist').exists()) {
                    $(this).children('.header__sublink').removeClass('disabled');
                    $(this).children('.header__sublist').hide();
                }
            }
        })
        .click(function (e) {
            e.stopPropagation();
            if (isMobile() && $(this).children('.header__sublist').exists()) {
                $(this).children('.header__sublink').toggleClass('disabled');
                $(this).children('.header__sublist').toggle();
            }
        }
        );

    
    function bindAdvClick() {
        if ($(window).width() < 744) {
            $('.header__subitem--adv').off('click.adv').on('click.adv', function () {
                $('.header__subitem--collapse-mobile').toggle(600);
                $('.header__submenu-arrow').toggleClass('open');
            });
        } else {
            $('.header__subitem--adv').off('click.adv');
            $('.header__subitem--collapse-mobile').show();
        }
    }
    
    bindAdvClick();
    $(window).on('orientationchange resize', bindAdvClick);


    $('.list__more-advantages').on('click', function () {
        let parentList = $(this).closest('ul');
        parentList.find('.more-advantages__arrow').toggleClass('down');
        parentList.find('.more-advantages__item').each(function () {
            $(this).slideToggle('slow');
        });
    });

    $('.absolute-phone__button').on('click', () => {
        $('html, body').animate({
            scrollTop: $('.absolute-phone__button').offset().top - $('#header').height() - 50
        }, 700, 'swing');
    });

    $('.scroll-sign-up').on('click', () => {
        $('html, body').animate({
            scrollTop: 0
        }, 700, 'swing');
    });

    //activate fading
    if ($(document).width() > 568) {
        $('html, body').animate({
            scrollTop: $(window).scrollTop() - 1
        }, 700, 'swing');
    }

    $(document).on('scroll', function () {
        let doc = $(this);
        if (doc.width() > 1200) {
            if (doc.scrollTop() > 300) {
                $('.header__item--sign-in').fadeIn();
            } else {
                $('.header__item--sign-in').fadeOut();
            }
        }
        if (doc.width() > 568) {
            $('.scroll-fade').each(function (index, element) {
                if (come(element)) {
                    $(element).addClass('active');
                }
            });
        }
    });

    if ($('.testimonials').length > 0) {
        $('.testimonials__user-item').on('click', function () {
            let review = $(this).data('review');
            if (!$(this).hasClass('active')) {
                $('.testimonials__review-item').hide();
                $('.testimonials__user-item').removeClass('active');
                $('.testimonials__review-item[data-review="' + review + '"]').fadeIn();
                $(this).addClass('active');
            }
        });
    }

    if ($('.blog__arrow-top').length > 0) {
        $('.blog__arrow-top').on('click', function () {
            $('html, body').animate({
                scrollTop: 0
            }, 1000);
        });
    }

    if ($('.slider--circles__wrapper').length > 0) {
        $('.slider--circles__wrapper').css('padding-left', $('.header__container').css('margin-right'));
        $(window).on('resize', function () {
            $('.slider--circles__wrapper').css('padding-left', $('.header__container').css('margin-right'));
        });
    }

    $('.input--phone__code').each(function () {
        rightPxCaret($(this));
        $(this).on('change', function () {
            let codeField = $(this);
            rightPxCaret(codeField);
        });
    });
    function rightPxCaret(codeField) {
        let textNumber = codeField.find('option:selected').text().length - 1;
        let rightPxArr = ['30px', '20px', '10px', '0'];
        $('#' + codeField.attr('id') + ' ~ .input--phone__caret').css('right', rightPxArr[textNumber - 1]);
    }


    if ($('.cp-table__category').length > 0) {
        cutCategory();
    }

    hashAutoScrollerFn();
});

$(function () {
    function getWindowGUID() {
        var windowGUID = generateGUID();

        var topMostWindow = window;
        while (topMostWindow != topMostWindow.parent) {
            topMostWindow = topMostWindow.parent;
        }

        if (!topMostWindow.name.match(/^GUID-/)) {
            topMostWindow.name = 'GUID-' + windowGUID;
        }

        return topMostWindow.name;
    }

    var guid = getWindowGUID();
    var guids = new Array();

    if ($.cookie('window_guids') !== undefined) {
        guids = JSON.parse($.cookie('window_guids'));

        var is_add = true;
        guids.forEach(function (entry) {
            if (entry === guid) {
                is_add = false;
            }
        });
        if (is_add) {
            guids.push(guid);
        }
    } else {
        guids.push(guid);
    }

    $.cookie('window_guids', JSON.stringify(guids), { expires: 365, path: '/' });

    window.onbeforeunload = function () {
        if ($.cookie('window_guids') !== undefined) {
            var guid = getWindowGUID();
            var guids = JSON.parse($.cookie('window_guids'));

            var index = guids.indexOf(guid);
            guids.splice(index, 1);

            $.cookie('window_guids', JSON.stringify(guids), { expires: 365, path: '/' });
        }
    };

    if (window.innerWidth > 980) {
        is_mobile = false;

        var on_show_bounce_form = $.cookie('bounce_form');
        if (on_show_bounce_form === undefined && $('.bounce-register').length) {
            $(document).bind('mouseleave', function (e) {
                var mouseY = parseInt(e.pageY - $(window).scrollTop(), 10);
                var dlg_open = false;
                if ($('.bounce-register').length) {
                    dlg_open = $('#divDialog').is(':visible');
                }
                if (mouseY < 0 && !dlg_open) {
                    $.ajax({
                        type: 'POST',
                        url: '/',
                        dataType: 'json',
                        data: 'is_show_bounce_form=true',
                        success: function (data) {
                            if (data.success === true) {
                                var ids = data?.data ? JSON.parse(data.data) : [];
                                if (ids.length <= 1) {
                                    $.cookie('bounce_form', 1, { expires: 365, path: '/' });

                                    if ($('#sign-up').is(':visible')) {
                                        $('#sign-up').fadeOut(1);
                                    }

                                    $('.bounce-register--old').css('display', 'block');

                                    $('.modal__close').click(function () {
                                        $('#bounce-popup').hide();
                                        $('#bounce-popup .has-error').removeClass('has-error');
                                        $('#bounce-popup .modal__error').text('');
                                        $('#bounce-popup [id^="signup-email"]').val('');
                                    });

                                }
                            }
                        }
                    });
                }
            });
        }
    } else {
        is_mobile = true;
    }

    // NEW MAIN
    $('.faq__btn').on('click', function () {
        let openedQuestion = $('#faq-list .open .faq__btn')[0];
        let currentQuestion = $(this)[0];
        $('.faq__answer').slideUp();
        $('.list-faq__item').removeClass('open');
        $('.faq__btn').text('+');
        if (currentQuestion != openedQuestion) {
            $(this).text('-');
            $(this).closest('.list-faq__item').addClass('open');
            $(this).closest('.list-faq__item').find('.faq__answer').slideDown();
        }
    });

    // OPEN IN SAME WINDOW MOBILE
    if (document.body.clientWidth <= 768 && $('.button-self-mobile').length > 0) {
        $('.button-self-mobile').each(function () {
            $(this).attr('target', '_self');
        });
    }

    // SUBSCRIBTIONS HOVER
    if ($('.plans').length > 0) {
        $('.plans__item').on('mouseenter', function () {
            $('.plans__item').removeClass('plans__item--blue');
            $(this).addClass('plans__item--blue');
        });
        $('.plans__item').on('click', function () {
            $('#sign-up input[name="SignUp[form_id]"]').val($(this).data('form'));
            $('#sign-up, #overlay').fadeIn(1);
        });
    }

    initCallbackModalFn();

    initTabs();
});


/**
 * init modal callback
 * */
function initCallbackModalFn() {
    let callback_btn = $('.header__call');

    if (callback_btn.length) {
        let modal = $('#callback_modal');
        let form = $('#callback_form');
        let textarea = $('textarea[name*="inquiry"]', form);
        let counter = $('#callback_counter');
        let close = $('.callback__close', modal);
        let submitted = false;

        callback_btn.click(function () {
            modal.css('display', 'flex');
            $('.close-icon').css('display', 'block');
            $('.callback__request').show();
            $('.callback__answer').hide();
        });

        modal.on('click', function (e) {
            let wrapper = $('.callback__wrapper');
            if (!wrapper.is(e.target) && wrapper.has(e.target).length === 0) {
                wrapper.closest('.callback').find('.callback__close').trigger('click');
            }
        });

        textarea.on('input', function () {
            counter.text($(this).val().length);
        });

        close.click(function () {
            modal.hide();
            counter.text('0');
            form.trigger('reset');
        });

        form.on('beforeSubmit', function () {
            if (submitted) return false;
            submitted = true;
            $.ajax({
                data: $(this).serialize(),
                method: 'POST',
                url: $(this).attr('action'),
                success: function (data) {
                    if (true === data) {
                        counter.text('0');
                        form.trigger('reset');
                        $('.callback__request').hide();
                        $('.callback__answer').show();
                    }
                },
                complete: () => { submitted = false }
            });
            return false;
        });
    }
}


/**
 * init tabs plugin for list with class tablist
 * */
function initTabs() {
    $('.tablist').each(function () {
        var _list = $(this),
            _links = $('a', _list);

        _links.each((i, el) => {
            var _link = $(el),
                _href = _link.attr('href'),
                _tab = $(_href);

            if (_link.hasClass('active')) _tab.show();
            else _tab.hide();

            _link.click((e) => {
                e.preventDefault();
                _links.filter('.active').each(function () {
                    $($(this).removeClass('active').attr('href')).hide();
                });
                _link.addClass('active');
                _tab.show();
            });
        });
    });
}

/**
 * функция осуществляет автоскролл к элементу с id или name
 * при загрузке страницы с соответствующим хэшем в url
 * или клике на ссылку с соответствующим href в родительском контейнере с классами
 * autoscroll-links или toc_list.
 * Предпочтительно использовать id.
 * Так же может работать как опенер после события автоскролла,
 * если родителю с id добавить класс open-after-scroll,
 * а тригеру опенера - класс open-after-scroll__trigger
 * */
function hashAutoScrollerFn() {
    let _hash = window.location.hash;
    let _autoscroll_links = $('.autoscroll-links a, .toc_list a');
    let _animateFn = (el) => {
        let _opened = false;
        $('html, body').animate({
            scrollTop: $(el).offset().top - document.getElementById('header').offsetHeight
        }, 500, () => {
            if (el.hasClass('open-after-scroll') && !_opened) {
                _opened = true;
                el.find('.open-after-scroll__trigger').trigger('click');
            }
        });

    }
    let _targetFn = (hash) => $(hash + ', [name="' + hash.substring(1) + '"]');

    if (_hash) {
        let _target = _targetFn(_hash);
        if (_target.length) {
            _animateFn(_target);
        }
    }

    _autoscroll_links.on('click', function (e) {
        e.preventDefault();
        let _href = $(this).attr('href');
        let _target = _targetFn(_href);

        if (_target.length) {
            _animateFn(_target);
            window.location.hash = _href;
        }
    });
}

function generateGUID() {
    var s4 = function () {
        return (
            Math.floor(
                Math.random() * 0x10000
            ).toString(16)
        );
    };

    return (
        s4() + s4() + '-' +
        s4() + '-' +
        s4() + '-' +
        s4() + '-' +
        s4() + s4() + s4()
    );
}

function loading_form_check_error(form, button_text, counter) {
    if (form.find('.has-error').length) {
        form.find('.btn-loading').html(button_text);
        form.find('.btn-loading').removeAttr('disabled');
        return true;
    }
    counter++;
    if (counter < 100) {
        // console.log(counter);
        setTimeout(function () {
            loading_form_check_error(form, button_text, counter);
        }, 1000);
    }
}

if ($('div').is('#article--content')) {
    $('#blog-progress-bar').show();
    $(window).on('scroll', function () {
        var scrollValue = $(window).scrollTop() * 100 / ($('#article--content').height() - 500);
        $('#blog-progress-bar').val(scrollValue);
    });
}

function gup(name) {
    name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    var regexS = '[\\?&]' + name + '=([^&#]*)';
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.href);
    if (results == null) {
        return '';
    }
    else {
        return results[1];
    }
}

function come(elem) {
    let docViewTop = $(window).scrollTop(),
        docViewBottom = docViewTop + $(window).height(),
        elemTop = $(elem).offset().top,
        elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function cutCategory() {
    $('.cp-table__category').each(function () {
        let categories = $(this),
            length = categories.outerWidth(),
            lengthAll = 0,
            count = 0;
        categories.find('.cp-table__badge').each(function () {
            lengthAll += $(this).outerWidth();
            if ((lengthAll + 85) > length) {
                count++;
                $(this).hide();
            }
        });
    });
}

// (function () {
//     if (typeof EventTarget !== "undefined") {
//         let func = EventTarget.prototype.addEventListener;
//         EventTarget.prototype.addEventListener = function (type, fn, capture) {
//             if (this) {
//                 this.func = func;
//                 if (typeof capture !== "boolean") {
//                     capture = capture || {};
//                     capture.passive = false;
//                 }
//                 this.func(type, fn, capture);
//             }
//         };
//     }
// }());

// function openCalendly() {
//     Calendly.initPopupWidget({ url: `https://calendly.com/helena-adsy/demo-call` }); return false;
// }

document.addEventListener('DOMContentLoaded', () => {
    const calendly = document.querySelector('.button--demo-call-new');
    if (calendly) {
        calendly.addEventListener('click', () => {
            Calendly.initPopupWidget({ url: `https://calendly.com/helena-adsy/demo-call` });
            return false;
        })
    }

    // const blogNextArticle = document.querySelector('.blog__next-article--wrapper');
    // function checkIfScrolledToMiddle() {
    //     const scrollY = window.scrollY || window.pageYOffset;
    //     const viewportHeight = document.documentElement.clientHeight;
    //     const documentHeight = document.documentElement.scrollHeight;

    //     const middleOfPage = documentHeight / 2.5;

    //     if (scrollY + (viewportHeight / 2.5) >= middleOfPage) {
    //         blogNextArticle.style.opacity = '1';
    //         return true;
    //     }

    //     return false;
    // }

    // if (blogNextArticle) {
    //     window.addEventListener('scroll', checkIfScrolledToMiddle);
    // }
});
/*jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("touchstart", handle, { passive: false });
        } else {
            this.addEventListener("touchstart", handle, { passive: true });
        }
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("touchmove", handle, { passive: false });
        } else {
            this.addEventListener("touchmove", handle, { passive: true });
        }
    }
};*/


window.onload = function () {
    const player = document.querySelectorAll('lottie-player');
    if (player.length > 0) {
        if ($(window).width() > 1199) {

            player.forEach((el) => {
                el.seek(0);
            });

        }
    } else {
        console.log('no player');
    }
};

$(document).ready(function () {
    const msfModal = document.querySelector('#apiServiceModal');
    const msfInputs = document.querySelectorAll('#apiServiceModal input, #apiServiceModal textarea');
    $(msfInputs).on('focus change', function () {
        $(msfModal.querySelectorAll('.has-error')).each(function (index) { console.dir(this); $(this).removeClass('has-error') })
    })
});